import {API} from "../../Services";

async function StoreOnlineSearch(merchantId, search,page=1,sort,startPrice,endPrice,available,brands=""){
    let token =  localStorage.getItem('token');
    return API.get(`/shop/${merchantId}/product/?search=${search}&page=${page}&${sort}&price__gt=${startPrice}&price__lt=${endPrice}&is_available=${available}${brands}`,{headers: { 'Authorization':  `Bearer ${token}`}});
}

async function StoreOnlineSearchPAge(merchantId, search,page=1,sort,startPrice,endPrice,available,brands=""){
    let token =  localStorage.getItem('token');
    return API.get(`/shop/${merchantId}/product/?search=${search}&page=${page}&${sort}&price__gt=${startPrice}&price__lt=${endPrice}&is_available=${available}${brands}`,{headers: { 'Authorization':  `Bearer ${token}`}});
}

export {StoreOnlineSearch,StoreOnlineSearchPAge}
 
